import React from "react";
import { Navigate, RoutesProps } from "react-router-dom";
import { appLinks } from "./routes";

interface Props extends RoutesProps {
  isAuthenticated: boolean;
  children: React.ReactElement;
}

const PrivateRoute: React.FC<Props> = ({
  isAuthenticated,
  children,
}: Props) => {
  return isAuthenticated ? children : <Navigate to={appLinks.signIn.link} />;
};

export default PrivateRoute;
